
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-home-smile-line text-2xl text-blue-400"></i>
              </div>
              <span className="ml-2 text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                KAILE BRIGHT
              </span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              Professional home cleaning services that make your life easier. We provide reliable, thorough, and eco-friendly cleaning solutions for your home.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">Regular Cleaning</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">Deep Cleaning</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">Move-in/out Cleaning</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">Post-Construction</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="text-gray-300">
                <i className="ri-phone-line mr-2"></i>
                (234) 376-0778
              </li>
              <li className="text-gray-300">
                <i className="ri-mail-line mr-2"></i>
                contact@kailebright.com
              </li>
              <li className="text-gray-300">
                <i className="ri-map-pin-line mr-2"></i>
                2322 21st St SW, Akron, OH 44314
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 KAILE BRIGHT Home Services. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-blue-400 text-sm cursor-pointer mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
